var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankssvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 86.6667,
    fill: "#EC1C23",
    stroke: "#FFE0E1",
    strokeWidth: 10.8333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 85.667L83.8333 98.3337L102.833 117.334L115.5 66.667L58.5 88.8337L71.1667 95.167L77.5 114.167L87 101.5",
    stroke: "white",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankssvg);
export default __webpack_public_path__ + "static/media/Thankssvg.a336683dca26584b0478b1326b0872e4.svg";
export { ForwardRef as ReactComponent };